<template>
  <div class="min-w-0">
    <div
      v-if="props.title"
      class="mb-xs flex flex-wrap items-center gap-xs"
      :class="{ 'border-2 border-red': errors?.length && !isContentUnfolded }"
    >
      <div class="text-2xl font-bold">
        {{ props.title }}
      </div>
      <IconButton
        v-if="isFoldable"
        :icon="isContentUnfolded ? Icon.UP_ARROW : Icon.DOWN_ARROW"
        class="!h-md"
        @click="isContentUnfolded = !isContentUnfolded"
      />
      <slot name="actions" />
    </div>
    <div class="grid min-w-0 gap-xs px-sm" :class="{ '!hidden': !isContentUnfolded }">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { watch } from "vue";
import { Icon } from "../assets/icons/Icon";
import { useErrors } from "../errors/useErrors";
import IconButton from "./IconButton.vue";

const props = defineProps<{
  title?: undefined | string;
  isFoldable?: true;
}>();

const isContentUnfolded = defineModel<undefined | boolean>({
  default: true,
});

const { errors } = useErrors();

watch(errors, (newErrors) => {
  if (newErrors?.length) {
    isContentUnfolded.value = true;
  }
});
</script>
